/* eslint-disable import/max-dependencies */
import type { FC } from "react";
import React from "react";
import { Helmet } from "react-helmet";
import { SetupCard, withHookPropsState, Table } from "@fas/cpa-cabinet-ui";
import { withStyles } from "@mui/styles";
import { usePagination } from "@fas/cpa-state-manager/redux/hooks";
import { useSelector } from "react-redux";
import { getLoadingState } from "@fas/cpa-state-manager/services/selectors/loading";
import { getTableFields } from "@fas/cpa-state-manager/services/selectors/table";
import { Box } from "@mui/material";
import {
  setupCardStyles,
  reportTableStyles,
  paymentHistory,
} from "../../styles";
import { PAYMENT_HISTORY_TABLE } from "../../constants";
import { usePaymentHistoryActions, usePaymentHistoryTable } from "../../hooks";
import withNoData from "../WithNoData";
import Pagination from "../Pagination";
import PaymentHistoryActions from "../PaymentHistoryActions";
import type { Props } from "./types/PaymentHistory.types";
import ReportSkeletonLoading from "../Report/ReportSkeletonLoading";
import { useTableNoData } from "../../hooks/useTableNoData";
import NoData from "../NoData";
import type { PaymentHistoryColumnData } from "../../hooks/usePaymentHistory/usePaymentHistory";

const TableWithNoData = withHookPropsState(
  withNoData(
    () => null,
    () => (
      <Box
        sx={{
          height: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <NoData
          headerText="No data available for the selected filters"
          text="Select the right filters to see your results, or try new cool offers to give your stats a boost!"
        />
      </Box>
    )
  ),
  useTableNoData
);

const Actions = withHookPropsState(
  PaymentHistoryActions,
  usePaymentHistoryActions
);
const PaymentHistoryTable = withHookPropsState(
  Table<PaymentHistoryColumnData>,
  usePaymentHistoryTable
);
const PaymantHistoryPagination = withHookPropsState(Pagination, usePagination);
const ReportLoading = withHookPropsState(
  ReportSkeletonLoading,
  ({ tableKey }: { tableKey: string }) => {
    const isLoading: boolean = useSelector((state) =>
      getLoadingState(state, tableKey)
    );
    return {
      isLoading,
      fieldsLength:
        useSelector((state) => getTableFields(state, tableKey)).length - 1,
    };
  }
);
const StyledSetupCard = withStyles(setupCardStyles)(SetupCard);
const StyledActions = withStyles(paymentHistory)(Actions);
const StyledTable = withStyles(reportTableStyles)(PaymentHistoryTable);

const PaymantHistory: FC<Props> = () => (
  <StyledSetupCard title="Payment History">
    <Helmet>
      <title>
        Payment history
      </title>
    </Helmet>
    <StyledActions hookProps={undefined} />
    <StyledTable hookProps={undefined}>
      <ReportLoading hookProps={{ tableKey: PAYMENT_HISTORY_TABLE }} />
    </StyledTable>
    <TableWithNoData hookProps={{ tableKey: PAYMENT_HISTORY_TABLE }} />
    <PaymantHistoryPagination hookProps={PAYMENT_HISTORY_TABLE} />
  </StyledSetupCard>
);

export default PaymantHistory;
